/** Leads to Get access page */
export enum GetAccessLink {
  EN = 'https://bkbn.com/contact',
  DE = 'https://bkbn.com/de/kontakt',
  FR = 'https://bkbn.com/fr/contact',
  ES = 'https://bkbn.com/es/contacto',
  NL = 'https://bkbn.com/nl/contact',
  ALL_PURPOSE = 'https://bkbn.com/contact'
}
